import { mainLayoutLocators } from '@locators/main-layout';
import useToasts from '../useToasts';
import Toast from './Toast';
import { Toast as AnvilToast } from '@servicetitan/design-system';

/**
 * Responsible for reading the toasts from the ToastModule and rendering them.
 */
const ToastsGroup = () => {
  const { toasts } = useToasts();

  return (
    <AnvilToast.Group>
      {toasts.map((toast) => (
        <Toast
          id={mainLayoutLocators.toastGroup.toast}
          key={`toast-${toast.createdAt}`}
          createdAt={toast.createdAt}
          title={toast.title}
          status={toast.status}
          primaryActionName={toast.primaryActionName}
          onPrimaryActionClick={toast.onPrimaryActionClick}
          secondaryActionName={toast.secondaryActionName}
          onSecondaryActionClick={toast.onSecondaryActionClick}
          duration={toast.duration}
          toastBody={toast.toastBody}
          onClose={toast.onClose}
        />
      ))}
    </AnvilToast.Group>
  );
};

export default ToastsGroup;
